import React from "react";
import styled from "styled-components";
import Item from "./Item";
import { graphql } from "react-apollo";
import gql from "graphql-tag";
import { Title } from "../../../theme/index";

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin: 2em auto;
  padding: ${props => props.padding};
  align-items: center;
  @media (max-width: 1100px) {
    width: 100%;
    margin: 1em auto;
  }
`;

const Grid = styled.div`
  width: 75%;
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fit, minmax(275px, 1fr));
  grid-auto-rows: 210px;
  margin: 2em auto;
  @media (max-width: 1100px) {
    width: 100%;
    margin: 1em auto;
  }
`;

const Div = styled.div`
  border: 1px solid #ffaf77;
  width: 30%;
  background-color: #ffaf77;
  margin: 0 auto;
`;

function SuggestedCourseForBundles({ data: { error, courses } }) {
  if (error) return <h1>Error fetching courses!</h1>;

  if (courses && courses.length >= 1) {
    return (
      <Wrapper>
        <Title professionsub>You may also need...</Title>
        <Div />
        <Grid>
          {courses &&
            courses.map((key, index) => {
              return (
                <Item
                  key={index}
                  name={key.name}
                  link={key.id && key.id}
                  img={
                    key.courseCard &&
                    `https://media.graphcms.com/${key.courseCard.handle}`
                  }
                />
              );
            })}
        </Grid>
      </Wrapper>
    );
  } else {
    return null;
  }
}

export const courses = gql`
  query courses($id: ID) {
    courses(where: { suggestedCoursesForBundles_some: { id: $id } }) {
      id
      courseCard {
        handle
      }
    }
  }
`;



export default graphql(courses, {
  props: ({ data }) => ({
    data
  }),
  options() {
    let id = window.location.href.split("/")[3];
    return {
      variables: {
        id: id
      }
    };
  }
})(SuggestedCourseForBundles);



// WEBPACK FOOTER //
// ./src/components/screens/Course/components/SuggestedCoursesForBundles.jsx